class ProductRecommendations {
  constructor() {
    this.init();
  }

  init() {
    // Initialize sliders when DOM is ready
    this.initSliders();
    this.observeForNewSliders();
  }

  observeForNewSliders() {
    // Shopify replaces the `<product-recommendations>` children asynchronously.
    // Without observing, Splide may mount before the slider markup exists.
    if (window.__productRecommendationsMutationObserverInitialized) return;
    window.__productRecommendationsMutationObserverInitialized = true;

    const observer = new MutationObserver(() => {
      if (document.querySelector('.product-recommendations__slider')) {
        this.initSliders();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  initSliders() {
    const sliders = document.querySelectorAll('.product-recommendations__slider');
    
    sliders.forEach(slider => {
      const section = slider.closest('.product-recommendations');

      // Avoid double-mounting when Shopify re-renders sections.
      if (slider.dataset.productRecommendationsSplideInitialized === 'true') {
        return;
      }
      slider.dataset.productRecommendationsSplideInitialized = 'true';

      const autoplaySpeedSeconds = parseInt(section?.dataset.autoplaySpeed || '3', 10);
      const showArrows = section?.dataset.showArrows === 'true';
      const showDots = section?.dataset.showDots === 'true';

      const arrowsEnabled = showArrows && slider.querySelector('.splide__arrows');

      new Splide(slider, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        // Spacing is handled via CSS vars on `.splide__list` / `.splide__slide`.
        gap: 0,
        pagination: false,
        arrows: !!arrowsEnabled,
        autoplay: false,
        interval: (autoplaySpeedSeconds || 3) * 1000,
        pauseOnHover: true,
        pauseOnFocus: true,
        breakpoints: {
          768: {
            perPage: 1.5,
            arrows: false
          }
        }
      }).mount();
    });
  }

  getPerPage() {
    const width = window.innerWidth;
    if (width >= 1024) return 4;
    if (width >= 768) return 3;
    if (width >= 480) return 2; 
    return 1;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductRecommendations());
} else {
  new ProductRecommendations();
}

// Re-initialize on Shopify section events
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('product-recommendations')) {
    new ProductRecommendations();
  }
});

document.addEventListener('shopify:section:reorder', (event) => {
  if (event.detail.sectionId.includes('product-recommendations')) {
    new ProductRecommendations();
  }
});
